import { Controller, Payload } from "../../config/controller";
import { ApplicationState } from "../../../core/store";
import { bindActionCreators, Dispatch } from "redux";

import { initialValueStatusAppState, StatusAppActions, StatusAppState } from "./root.model"
import { action } from "typesafe-actions";
import { call, put, takeLatest } from "redux-saga/effects";
import { ResultDb } from "../../services/db";
import { auth } from "../../services/auth";
import { initialValueUsuario, Usuario, UsuarioState ,UsuarioActions} from "../usuario/usuario.model";
import { mapStateToUsuarioProps, usuarioController } from "../usuario/usuario.controller";
import { UserAuth } from "../../config/data.types";

export interface StatusAppViewProps {
    statusAppState: StatusAppState
    statusAppActions: StatusAppActions
    usuarioState: UsuarioState
    usuarioActions:UsuarioActions
}


class StatusAppController extends Controller<any, StatusAppState, StatusAppActions> {
    constructor() {
        super("statusapp", initialValueStatusAppState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
            START_APP: `@${this.moduloName}/START_APP`,
            LOGIN: `@${this.moduloName}/LOGIN`,
            LOGOUT:`@${this.moduloName}/LOGOUT`
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
            startApp: () => action(this.actionsType.START_APP),
            login:(login:string,pass:string)=>action(this.actionsType.LOGIN,{login,pass}),
            logOut:()=>action(this.actionsType.LOGOUT)

        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
            takeLatest(this.actionsType.START_APP, this.startAppEffects.bind(this)),
            takeLatest(this.actionsType.LOGIN, this.loginEffects.bind(this)),
            takeLatest(this.actionsType.LOGOUT, this.logOutEffects.bind(this))
        ]
    }

    private * startAppEffects(actions: Payload) {
        try {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: true, msg: "Inicializando o sistema...", error: false },
                this.actionsType.startAppEffects
            ))

            let resp: ResultDb<any> = yield call(auth.singInFast);
            console.log("resposta singInFast", resp);
            if (resp.status === "ok") {
                //fazer uma busca nos usuarios
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: "Verificando usuários do sistema...", error: false, credencial:resp.row },
                    this.actionsType.startAppEffects
                ))

                let respUsers:ResultDb<any> = yield call(usuarioController.read)
                console.log("resposta de buscar usuarios", respUsers)
                if (respUsers.status === "ok") {
                    //verificar se ja tem pelo menos 1 usuario adm
                    if (respUsers.rows && respUsers.rows.length > 0) {
                        yield put(this.reducer.resultAfterEffects(
                            { ...this.state, loading: false, msg: "Sistema inicializado com sucesso!", error: false, start: true },
                            this.actionsType.startAppEffects
                        ))
                    } else {
                        //inserir o usuario adm para realizar o primeiro login
                        yield put(this.reducer.resultAfterEffects(
                            { ...this.state, loading: false, msg: "Realizando configurações no usuário do sistema...", error: false },
                            this.actionsType.startAppEffects
                        ))

                        let userAdm: Usuario = {
                            ...initialValueUsuario,
                            login: "admin",
                            nome: "Administrador do Sistema",
                            senha:process.env.PARCEL_USER_ADMIN,
                            ativo: true,
                            created_at: new Date().toISOString(),
                        };
                        let respSalvarUser: ResultDb<Usuario> = yield call(usuarioController.db.salvar, userAdm);
                        console.log("resposta de salvar usuario startApp", respSalvarUser);
                        if (respSalvarUser.status === "ok") {
                            yield put(this.reducer.resultAfterEffects(
                                { ...this.state, loading: false, msg: "Configurações iniciais concluidas com sucesso, sistema inicializado.", error: false, start: true },
                                this.actionsType.startAppEffects
                            ))
                        } else {
                            yield put(this.reducer.resultAfterEffects(
                                { ...this.state, loading: false, msg: "Falha na configuração do usuario admin, detalhes: " + respSalvarUser.msg, status: "error", error: true, showAlert: true },
                                this.actionsType.startAppEffects
                            ))
                        }
                    }
                } else {
                    yield put(this.reducer.resultAfterEffects(
                        { ...this.state, loading: false, msg: "Falha na busca dos usuarios do sistema na inicialização, detalhes: " + respUsers.msg, status: "error", error: true, showAlert: true },
                        this.actionsType.startAppEffects
                    ))
                }
            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: "Nenhuma conta encontrada para inicializar automaticamente." + resp.msg, status: "error", error: true, showAlert: false },
                    this.actionsType.startAppEffects
                ))
            }
        } catch (error: any) {
            console.log("error startAppEffects", error);
            let msg = "Ops, ocorreu uma falha em startAppEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.startAppEffects
            ))
        }
    }

    private * loginEffects(actions: Payload) {
        try {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: true, msg: "Realizando login na conta...", error: false },
                this.actionsType.loginEffects
            ))

            let resp: ResultDb<any> = yield call(auth.logIn, actions.payload.login, actions.payload.pass);
            console.log("resposta logIn", resp);
            if (resp.status === "ok") {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: "Login realizado com sucesso!", error: false, credencial: resp.row, start: true },
                    this.actionsType.loginEffects
                ))
            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: "Falha no login do usuário, detalhes: " + resp.msg, status: "error", error: true, showAlert: true },
                    this.actionsType.loginEffects
                ))
            }
        } catch (error: any) {
            console.log("error loginEffects", error);
            let msg = "Ops, ocorreu uma falha em loginEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.loginEffects
            ))
        }
    }

    private * logOutEffects(actions: Payload) {
        try {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: true, msg: "Realizando logout da conta...", error: false },
                this.actionsType.logOut
            ))

            let resp: ResultDb<any> = yield call(auth.logOut);
            console.log("resposta logOut", resp);
            if (resp.status === "ok") {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: "Logout realizado com sucesso!", error: false, credencial: {} as UserAuth, start: false },
                    this.actionsType.logOut
                ))
            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: "Falha no logout do usuário, detalhes: " + resp.msg, status: "error", error: true, showAlert: true },
                    this.actionsType.logOut
                ))
            }
        } catch (error: any) {
            console.log("error logOutEffects", error);
            let msg = "Ops, ocorreu uma falha em logOutEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.logOut
            ))
        }
    }
}

export const statusAppController = new StatusAppController()

export const mapStateToStatusAppProps = (state: ApplicationState) => ({
    statusAppState: state.statusAppState,
    usuarioState: state.usuarioState,
})

export const mapDispatchToStatusAppProps = (dispatch: Dispatch) => ({
    statusAppActions: bindActionCreators({ ...statusAppController.reducer.actions }, dispatch),
    usuarioActions: bindActionCreators({ ...usuarioController.reducer.actions }, dispatch),
})